<template>
  <main class="k2-board" :class="{ 'k2-board--one': narrow }">
    <kds2-column
      v-if="narrow && current"
      ref="cols"
      :stage="current"
      :tickets="groups[current.key]"
      :dens="dens[current.key]"
      single
      v-bind="shared"
      v-on="$listeners"
    />
    <template v-else-if="calm">
      <section v-for="s in stages" :key="s.key" class="k2-col k2-col--calm" :data-c="s.tone" :data-s="s.key" :aria-label="$t(s.labelKey) + ', 0'">
        <div class="k2-colh">
          <span class="k2-ci"><k2-icon :n="s.icon" :s="19" /></span>
          <h2>{{ $t(s.labelKey) }}</h2>
          <span class="k2-n">0</span>
          <span class="k2-sp"></span>
        </div>
      </section>
      <div class="k2-calm">
        <k2-icon n="mdi-tray" :s="56" />
        <h3>{{ tx("calm.t") }}</h3>
        <div>{{ tx("calm.s") }}</div>
      </div>
    </template>
    <template v-else>
      <kds2-column
        v-for="s in stages"
        :key="s.key"
        ref="cols"
        :stage="s"
        :tickets="groups[s.key]"
        :dens="dens[s.key]"
        v-bind="shared"
        v-on="$listeners"
      />
    </template>
  </main>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import Kds2Column from "./Kds2Column.vue";
import kds2Text from "@/mixins/kds2Text";

// Ploča: kolone jedna pored druge, a na uskom ekranu samo izabrana kolona (tabovi su ispod).
export default {
  name: "Kds2Board",
  components: { K2Icon, Kds2Column },
  mixins: [kds2Text],
  props: {
    stages: { type: Array, required: true },
    groups: { type: Object, required: true },
    dens: { type: Object, required: true },
    narrow: { type: Boolean, default: false },
    current: { type: Object, default: null },
    calm: { type: Boolean, default: false },
    now: { type: Number, required: true },
    q: { type: String, default: "" },
    showRest: { type: Boolean, default: false },
    chooserId: { type: Number, default: null },
    lastEst: { type: Number, default: 15 },
    newIds: { type: Object, default: () => ({}) },
    filtered: { type: Boolean, default: false },
  },
  computed: {
    shared() {
      return {
        now: this.now,
        q: this.q,
        showRest: this.showRest,
        chooserId: this.chooserId,
        lastEst: this.lastEst,
        newIds: this.newIds,
        filtered: this.filtered,
      };
    },
  },
  methods: {
    // automatsko listanje svih kolona
    pageAll() {
      (this.$refs.cols || []).forEach((col) => col.pageScroll());
    },
  },
};
</script>
